import { lazy, Suspense } from "react";
import { Navigate, createBrowserRouter } from "react-router";

const OnboardingPage = lazy(() => import("@/pages/onboarding/onboarding-page"));
const LoginPage = lazy(() => import("@/pages/login/login-page"));
const PasswordResetPage = lazy(() => import("@/pages/login/password-reset-page"));
const loadingElement = (
  <main aria-busy="true" className="route-loading">
    Loading PetChef…
  </main>
);
const loginElement = (
  <Suspense fallback={loadingElement}>
    <LoginPage />
  </Suspense>
);
const onboardingElement = (
  <Suspense fallback={loadingElement}>
    <OnboardingPage />
  </Suspense>
);
const passwordResetElement = (
  <Suspense fallback={loadingElement}>
    <PasswordResetPage />
  </Suspense>
);

export const router = createBrowserRouter([
  { path: "/", element: <Navigate replace to="/login" /> },
  { path: "/login", element: loginElement },
  { path: "/reset-password", element: passwordResetElement },
  { path: "/onboarding", element: onboardingElement },
  { path: "*", element: <Navigate replace to="/login" /> },
]);
